import { File, Loader2, X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface UploadedFile {
  name: string;
  size: number;
  type: string;
  path: string;
}

interface FileListProps {
  files: UploadedFile[];
  onRemove: (path: string) => void;
  isUploading: boolean;
}

export function FileList({ files, onRemove, isUploading }: FileListProps) {
  return (
    <div className="space-y-2">
      {files.map((file) => (
        <div
          key={file.path}
          className="flex items-center justify-between p-3 bg-accent/50 rounded-lg"
        >
          <div className="flex items-center space-x-3">
            <File className="h-5 w-5" />
            <div>
              <p className="text-sm font-medium">{file.name}</p>
              <p className="text-xs text-muted-foreground">
                {(file.size / 1024 / 1024).toFixed(2)} MB
              </p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onRemove(file.path)}
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      ))}

      {isUploading && (
        <div className="flex items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-foreground" />
        </div>
      )}
    </div>
  );
}